/**
 * Hostname-based environment detection — the client-side signal for "am I
 * looking at dev or prod". Purely a function of the browser's hostname, so it
 * is synchronous and available at first render (no fetch, no flash).
 *
 * Vocabulary is shared with the client-error pipeline ("dev" = a laptop,
 * "staging" = the deployed euw2-dev box, "prod" = everything else) —
 * ClientErrorsPanel's env colors key off these exact strings, so do not
 * rename them. The server's ENVIRONMENT label (from /api/public-config) is a
 * display string only; visibility decisions (the DEV banner, hiding the team
 * chat page on prod) branch on THIS function, never on that label.
 */
export function detectEnv(host: string = window.location.hostname): "dev" | "staging" | "prod" {
  if (host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost")) return "dev";
  if (host === "dev.shopai.website" || host.endsWith(".dev.shopai.website")) return "staging";
  return "prod";
}
